import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ArtikelTierart } from '../../../components/tierart-selector/artikel-tierart';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Anwendung } from '../anwendung';
import { BehandlungsanfrageService } from '../behandlungsanfrage.service';
import { Identifikation } from '../identifikation';
import { Behandlungsanfrage, BehandlungsanfragePosition, BestellungStatus } from '../behandlungsanfrage';

import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { KieneSession } from '../../../../../projects/kiene-core/src/lib/services/local-storage/kiene-session';
import { BelegPositionInlineComponent } from '../../beleg-position/beleg-position-inline/beleg-position-inline.component';
import { ChangeCurrentClientService } from '../../../administration/client/change-current-client/change-current-client.service';
import { Location } from '@angular/common';
import { GruppeAuswaehlenSelektorComponent } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-auswaehlen-selektor/gruppe-auswaehlen-selektor.component';
import { BelegPositionInlineResult } from '../../beleg-position/beleg-position-inline/beleg-position-inline';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { Abgabebeleg } from '../../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg';

@Component({
    selector: 'kiene-behandlungsanfrage-detail',
    templateUrl: './behandlungsanfrage-detail.component.html',
    styleUrls: ['./behandlungsanfrage-detail.component.scss'],
})
export class BehandlungsanfrageDetailComponent implements OnInit {
    @ViewChild('positionInline') positionInline: BelegPositionInlineComponent;
    @ViewChild('gruppeSelektor')
    gruppeSelektor: GruppeAuswaehlenSelektorComponent;
    behandlungsanfrageId: string;
    behandlungsanfrage: Behandlungsanfrage = new Behandlungsanfrage();

    descriptionCtrl = new FormControl();

    selectedTierarztId: number;

    identifikationen: Observable<Identifikation[]>;
    anwendungen: Anwendung[] = [];

    zielDatumCtrl = new FormControl(new Date());

    apothekeCtrl = new FormControl();

    releaseAllowed = false;

    tierarten: ArtikelTierart[] = [];

    kieneSession: KieneSession;

    disabled = true;

    // query parameters for getting the neighbours of the entry
    aktuelleGruppe: Gruppe;

    mandantid: number;
    mandantname: string;

    mandant: Mandant;

    constructor(
        private readonly localStorageService: LocalStorageService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly location: Location,
        private readonly clientChangeService: ChangeCurrentClientService,
        private readonly messageService: MessageService,
        private readonly api: BehandlungsanfrageService,
        public dialog: MatDialog,
    ) {
        this.behandlungsanfrageId = this.route.snapshot.paramMap.get('id');

        this.route.queryParams.subscribe(params => {
            this.mandantid = params['mandantid'];
            this.mandantname = params['mandantname'];
        });

        this.kieneSession = this.localStorageService.getCurrentUser();
    }

    ngOnInit() {
        if (this.mandantid && this.mandantname) {
            this.mandant = new Mandant();
            this.mandant.mandant_id = this.mandantid;
            this.mandant.bezeichnung = this.mandantname;
        }

        this.localStorageService.watchCurrentClient().subscribe(client => {
            if (!this.behandlungsanfrage.kunde_id) {
                this.behandlungsanfrage.kunde_id = client.kunde_id;
                this.behandlungsanfrage.kunde = client.bezeichnung_final;
            }
        });

        if (this.behandlungsanfrageId !== 'neu') {
            this.loadBehandlungsanfrage();
        } else {
            this.zielDatumCtrl.setValue(new Date());
            this.behandlungsanfrage.status_id = 1;
            if (this.localStorageService.getCurrentClient()) {
                this.behandlungsanfrage.kunde_id = this.localStorageService.getCurrentClient().kunde_id;
                this.behandlungsanfrage.kunde = this.localStorageService.getCurrentClient().bezeichnung_final;
            }
            if (this.mandantid > -1) {
                this.disabled = false;
            }
            if (!this.behandlungsanfrage.kunde_id) {
                this.clientChangeService.openChangeDialog();
            }
        }
    }

    reload() {
        this.loadBehandlungsanfrage();
    }

    loadBehandlungsanfrage() {
        this.api.getById(Number.parseInt(this.behandlungsanfrageId, 10)).subscribe(response => {
            this.behandlungsanfrage = response;
            if (this.behandlungsanfrage.status_id === 2) {
                this.releaseAllowed = true;
            }

            this.selectedTierarztId = this.behandlungsanfrage.tierarzt_id;
            this.zielDatumCtrl.setValue(this.behandlungsanfrage.zieldatum);
            this.descriptionCtrl.setValue(this.behandlungsanfrage.bezeichnung);
            this.apothekeCtrl.setValue(this.behandlungsanfrage.apotheke === 1);
            if (this.behandlungsanfrage.status_id > 3) {
                this.apothekeCtrl.disable();
            }
            this.mandantid = this.behandlungsanfrage.mandant_id;
            this.mandant = new Mandant();
            this.mandant.mandant_id = this.behandlungsanfrage.mandant_id;
            this.mandant.bezeichnung = this.behandlungsanfrage.mandant;
            this.checkStatus();
        });
    }

    takeoverCurrentClient() {
        const currentClient = this.localStorageService.getCurrentClient();
        if (currentClient) {
            this.behandlungsanfrage.kunde_id = currentClient.kunde_id;
            this.behandlungsanfrage.kunde = currentClient.bezeichnung_final;
        }
    }

    save(statusId: number) {
        if (!this.behandlungsanfrage.kunde_id) {
            this.messageService.alertMessage('Bitte erst einen Betrieb auswählen! (ALT+B)');
            return;
        }

        this.behandlungsanfrage.status_id = statusId;
        this.behandlungsanfrage.bezeichnung = this.descriptionCtrl.value;
        this.behandlungsanfrage.zieldatum = this.zielDatumCtrl.value;

        this.behandlungsanfrage.apotheke = this.apothekeCtrl.value === true ? 1 : 0;

        const wasNew = this.behandlungsanfrageId === 'neu';

        this.api.save(this.behandlungsanfrage, this.mandantid).subscribe({
            next: response => {
                this.messageService.infoMessage('Die Behandlungsanfrage wurde erfolgreich gespeichert!');
                this.behandlungsanfrage = response;
                this.checkStatus();
                if (wasNew) {
                    this.location.replaceState(
                        this.router
                            .createUrlTree(['/belege/behandlungsanfragen', this.behandlungsanfrage.bestellung_id])
                            .toString(),
                    );
                }
            },
            error: error => {
                this.messageService.errorMessage('Die Behandlungsanfrage konnte nicht gespeichert werden!', error);
            },
        });
    }

    goBack() {
        window.history.go(-1);
    }

    removePosition(p: BehandlungsanfragePosition) {
        const index = this.behandlungsanfrage.positionen.indexOf(p);
        this.behandlungsanfrage.positionen.splice(index, 1);
        // Persist deletion immediately, same as inline position save flow.
        this.save(this.behandlungsanfrage.status_id);
    }

    transformToAbgabebeleg() {
        const input = new ConfirmDialogInput();
        input.headline = 'In Abgabebeleg umwandeln';
        input.text = 'Wollen Sie die Behandlungsanfrage wirklich in einen Abgabebeleg umwandeln?';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });

        dialogRef.afterClosed().subscribe({
            next: (response: ConfirmDialogResult) => {
                if (response?.confirmed) {
                    this.api.transformToAbgabebeleg(this.behandlungsanfrage).subscribe({
                        next: beleg => {
                            const abgabebeleg: Abgabebeleg = beleg;
                            this.messageService.infoMessage(
                                'Die Behandlungsanfrage wurde erfolgreich in einen Abgabebeleg umgewandelt!',
                            );
                            this.router.navigate(['belege', 'abgabebelege', abgabebeleg.abgabebeleg_id]).then();
                        },
                        error: error => {
                            this.messageService.errorMessage(
                                'Behandlungsanfrage konnte nicht in ein Abgabebeleg umgewandelt werden!, ',
                                error,
                            );
                        },
                    });
                }
            },
        });
    }

    duplicate() {
        this.api.duplicate(this.behandlungsanfrage, this.behandlungsanfrage.mandant_id).subscribe({
            next: response => {
                this.messageService.infoMessage('Die Behandlungsanfrage wurde erfolgreich dupliziert!');
                this.router.navigate(['belege', 'behandlungsanfragen', response.bestellung_id]).then();
            },
            error: error => {
                this.messageService.errorMessage('Die Behandlungsanfrage konnte nicht dupliziert werden!', error);
            },
        });
    }

    assignToMe() {
        this.behandlungsanfrage.tierarzt_id = this.kieneSession.tierarzt_id;
        this.save(this.behandlungsanfrage.status_id);
    }

    positionenSpeichern(result: BelegPositionInlineResult) {
        if (result?.positionen?.length > 0) {
            for (const posi of result.positionen) {
                const index = this.behandlungsanfrage?.positionen.findIndex(ba => {
                    return ba.ba_id === posi.ba_id;
                });
                if (index > -1) {
                    this.behandlungsanfrage.positionen.splice(index, 1, posi);
                } else {
                    this.behandlungsanfrage?.positionen.push(posi);
                }
            }
            this.save(this.behandlungsanfrage.status_id);
            this.positionInline.felderLeeren(true);
        }
    }

    aktuellePositionEditieren(p: any) {
        if (p && this.canEditBehandlungsanfrage()) {
            this.positionInline.ladePosition(p);
            this.gruppeSelektor.setzeGruppe(p.gruppe_id);
        }
    }

    setzeGruppe(gruppe: Gruppe) {
        this.aktuelleGruppe = gruppe;
    }

    canEditBehandlungsanfrage() {
        // kunde
        if (this.localStorageService.isCurrentUserKunde()) {
            if (this.behandlungsanfrage.status_id < BestellungStatus.AUFGEGEBEN) {
                return true;
            }
        } else {
            if (this.behandlungsanfrage.status_id < BestellungStatus.KOMMISSIONIERT) {
                return true;
            }
        }
        return false;
    }

    private checkStatus() {
        if (this.canEditBehandlungsanfrage()) {
            if (this.mandantid > -1) {
                this.disabled = false;
            }
        } else {
            this.disabled = true;
            this.zielDatumCtrl.disable();
            this.descriptionCtrl.disable();
        }
    }
}
